import { render } from "./AllCalendars.vue?vue&type=template&id=535c0ac9"
import script from "./AllCalendars.vue?vue&type=script&lang=js"
export * from "./AllCalendars.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__